import type { DashboardSearchParams } from "@entities/dashboard/dashboard";
import { useGetModelList } from "@entities/model/model";
import Dashboard from "@pages/dashboard/dashboard";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/dashboard/")({
	component: RouteComponent,
	validateSearch: (search: DashboardSearchParams) => {
		return {
			startDate: search.startDate || "",
			endDate: search.endDate || "",
			filters: search.filters || {},
			// `?userId[]=1` would otherwise arrive as an array typed as a string and
			// flow straight into the dropdown and the request body.
			userId: String(search.userId ?? ""),
		};
	},
});

function RouteComponent() {
	const { models } = useGetModelList();
	if ((models?.models?.length ?? 0) === 0) {
		return (
			<Navigate
				search={{
					search: "",
					startDate: "",
					endDate: "",
					page: 1,
					filterStatus: "",
					filters: {},
					tab: "single",
				}}
				to="/applications"
			/>
		);
	}
	return <Dashboard />;
}
